/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_PublishInputs */

const cs_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikovat`)
};

const en_action_publish = /** @type {(inputs: Action_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Action_PublishInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_publish = /** @type {((inputs?: Action_PublishInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_PublishInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_publish(inputs)
	return cs_action_publish(inputs)
});